<template>
  <div class="cardCustom">
    <div
      class="card cardCustom__side"
      :class="{
        'cardCustom__side--front': withDoubleSides,
        'cardCustom__side--front--active': backSide,
        'cardCustom__side--highlight': highlight,
      }"
      @click="changeActiveSide()"
    >
      <div>
        <div class="row">
          <div class="col-sm-12 col-lg-5" v-if="$slots.header">
            <slot name="header"></slot>
          </div>
          <div class="col-sm-12 col-lg-7" v-if="$slots.content">
            <slot name="content"></slot>
          </div>
        </div>
        <div v-if="$slots.footer">
          <hr />
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
    <div
      v-if="withDoubleSides"
      class="card cardCustom__side cardCustom__side--back cardCustom__side--back-1"
      :class="{
        'cardCustom__side--back--active': backSide,
      }"
    >
      <div>
        <div class="card-times" @click="changeActiveSide()">&times;</div>
        <div class="row mb-5">
          <div class="col-12" v-if="$slots.header_back">
            <slot name="header_back"></slot>
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-if="$slots.content_back">
            <slot name="content_back"></slot>
          </div>
        </div>
        <div v-if="$slots.footer_back">
          <hr />
          <slot name="footer_back"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cardWithSides',
  props: {
    title: String,
    subTitle: String,
    withDoubleSides: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backSide: false,
    };
  },
  methods: {
    changeActiveSide() {
      if (this.withDoubleSides) {
        this.backSide = !this.backSide;
        if (this.backSide) this.$gtag.event('Dashboard Card Opened', { method: 'Google' });
        else this.$gtag.event('Dashboard Card Closed', { method: 'Google' });
      }
    },
  },
};
</script>
<style></style>
